// extracted by mini-css-extract-plugin
export default {"wrap":"a08b10e59e75","accordionContent":"a107a5715be3"};